/*
 * @Date: 2020-05-29 18:24:51
 * @LastEditTime: 2020-05-29 18:37:18
 * @Description:
 */
import { judgeHost, onlineDomain } from './config';
import { isTest } from './utils/util';
export var ROUTER_BASENAME = 'operation-business';
// 保证线上的bsaeName是对的
if (isTest()) {
    ROUTER_BASENAME = 'operation-business';
}
export var PAGE_MAX_WIDTH = 480;
export var NORMAL_WIDTH = 375;
export var MOCK_TOKEN = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0eXBlIjoiQWNjb3VudFRva2VuIiwiaWQiOjExMTIsIm5pY2tuYW1lIjoibGnogIHluIgiLCJzZXgiOiIyIiwic3RhdHVzIjoibm9ybWFsIiwic3Vic2NyaWJlZCI6MSwicm9sZSI6ImxlY3R1cmVyIiwic3RhZmZfbmFtZSI6IuadjuePiiIsImlzX3N1cGVyX2FkbWluIjoxLCJpYXQiOjE1NjQ5OTY0NTMsImV4cCI6MTU2NTAxODA1M30.M0T1c5Zof7NPxRlHjsMWb7CEl5O3g9L7iSzGAuvaPm8";
export var SUCCESS_RESPONSE = { code: 0, msg: 'ok' };
export var BASE_URL = judgeHost;
export var UNAUTH_CODE = 9111; // 分享出去，不是本人的，没有认证
export var PROMOTION_TITLE = '微课推广';
export var MASTER_URL = onlineDomain;
export var TEST_SERVICE_URL = isTest() ? 'http://118.89.49.61:10088' : MASTER_URL;
export var WHITE_LIST = [
    '/audition',
    '/operation-business/audition',
    '/bargain/home',
    '/operation-business/bargain/home',
    '/bargain/detail',
    '/operation-business/bargain/detail',
    // '/operation-business/double-egg',
    // '/double-egg',
    'integral-game',
    'simple-detail',
    '/operation-business/simple-detail',
    '/operation-business/membercard/center',
    '/operation-business/membercard/activate',
    '/operation-business/membercard2/activate',
    '/operation-business/membercard/renew',
    '/operation-business/integral-game',
    '/operation-business/double/twelve',
    '/operation-business/spring/home',
    '/operation-business/spring/home/',
    '/operation-business/spring/channel',
    '/operation-business/cnov',
];
/**
 * 由于 推广系统部署在主站，为防止内鬼举报
 * 以下域名不能在 https://m.lizhiweike.com 域名下访问
 */
export var BAN_FOR_MASTER_LIST = [
    '/operation-business/audition',
    '/operation-business/bargain/home',
    '/operation-business/bargain/detail',
    '/operation-business/integral-game',
];
export var OFFICIAL_ACCOUNT = 'http://assets.maocanhua.cn/FkxqAbQq0LlnlH7OzMrSHLnU-N4b';
export var IPHONE5_HEIGHT = 568;
export var IPHONE5_WIDTH = 320;
export var ThemeType;
(function (ThemeType) {
    ThemeType["DEFAULT"] = "defaule";
    ThemeType["SANDBEACH"] = "sandbeach";
    ThemeType["SUMMER"] = "summer";
})(ThemeType || (ThemeType = {}));
export var ViewSizeType;
(function (ViewSizeType) {
    ViewSizeType["LARGE"] = "large";
    ViewSizeType["NORMAL"] = "normal";
    ViewSizeType["SMALL"] = "small";
    ViewSizeType["XSMALL"] = "x-small";
})(ViewSizeType || (ViewSizeType = {}));
export var DOCUMENT_BODY_ID = 'doc-body';



//////////////////
// WEBPACK FOOTER
// ./src/constants.ts
// module id = 49
// module chunks = 41